import {PureComponent} from 'react'

import LandingFreelance from './LandingFreelanceUniverse.jsx'

import header from './images/header-purchase.png?size=600'

const metaDescription = "Accédez à des missions en achats : directs, indirects et projets... Un accompagnement personnalisé et des projets adaptés à votre expertise. Découvrez nos offres."
const metaTitle = "Twineeds | Missions Achats et Supply | Consultants Indépendants"

export default class LandingFreelancePurchase extends PureComponent {
  render() {
    const headerBrief = <p>Twineeds propose aux <strong>consultants en achats et supply chain</strong> des <strong>missions sur-mesure</strong>. Rencontrez-nous pour parler de votre projet, nous identifions pour vous les opportunités, partout en France, adaptées à votre expertise.</p>

    return (
      <LandingFreelance
        headerImg={header.src}
        headerImgAlt="PC et portable montrant un site d'intermédiation pour consultants freelances et entreprise"
        headerBrief={headerBrief}
        metaDescription={metaDescription}
        metaOgDescription={metaDescription}
        metaTitle={metaTitle}
        metaOgTitle={metaTitle}
        sectorText="des achats"
        title="Consultant en Achats ou Supply Chain: recevez des missions ciblées"
        universeCode="purchase"
      />
    )
  }
}
